import logo from './logo.svg';
import './App.css';
import Generate from './components/Generate';
import Test from './components/Test';
import Navbar from './components/Navbar';
import AbstractGen from './components/AbstractGen';

const DEVMODE = false
let URL
let DEVURL = "http://localhost:5050"
let PRODUCTIONURL = "https://skills-engine-jobpostingbackend-kokwttjzkq-uc.a.run.app"

if (DEVMODE){
  URL = DEVURL
}
else{
  URL = PRODUCTIONURL
}


function App() {
  return (
    <div className={"App"}>
    <Navbar></Navbar>
  {/* <Generate></Generate> */}
<AbstractGen url={URL}></AbstractGen>
    </div>
  );
}

export default App;
